import RidingResult from '../models/RidingResult'
import PartyResult from '../models/PartyResult'
import { IPartyNumberMap } from '../models/TypeHelper'
import PartyResultMap from '../models/PartyResultMap'

class UniformSwingModel {
  public static differences(
    oldPolls: IPartyNumberMap,
    newPolls: IPartyNumberMap
  ): IPartyNumberMap {
    const differenceMap: IPartyNumberMap = {}
    Object.keys(oldPolls).forEach((key): void => {
      differenceMap[key] = newPolls[key] - oldPolls[key]
    })
    return differenceMap
  }

  public static apply(
    ridingResult: RidingResult,
    pollDifferences: IPartyNumberMap
  ): RidingResult {
    const totalVoteCount = ridingResult.totalVoteCount

    const existingPartyResultMap = ridingResult.partyResultMap
    const newPartyResultMap = new PartyResultMap()

    existingPartyResultMap.results().forEach((partyResult): void => {
      const percentDifference = pollDifferences[partyResult.party.key]
      const newPartyResult = new PartyResult(partyResult.party)
      const newPollValue = partyResult.votePercent + percentDifference
      newPartyResult.voteCount = Math.round(totalVoteCount * newPollValue)
      newPartyResultMap.setResult(newPartyResult)
    })

    return new RidingResult(newPartyResultMap, ridingResult.riding)
  }
}

export default UniformSwingModel
